import { render, staticRenderFns } from "./OpenIndex.vue?vue&type=template&id=59461d21&"
import script from "./OpenIndex.vue?vue&type=script&lang=js&"
export * from "./OpenIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports